// src/slice/domainSlice.jsx
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClientSignIn } from "../axios/api.js";

// Fetch domains (with optional filters)
export const fetchDomains = createAsyncThunk(
  "domains/fetchDomains",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const res = await axiosClientSignIn.get(`/domains?${queryParams}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Create domain
export const createDomain = createAsyncThunk(
  "domains/createDomain",
  async (domainData, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.post(`/domains`, domainData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update domain
export const updateDomain = createAsyncThunk(
  "domains/updateDomain",
  async ({ domainId, updates }, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.put(`/domains/${domainId}`, updates);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Delete domain
export const deleteDomain = createAsyncThunk(
  "domains/deleteDomain",
  async (domainId, { rejectWithValue }) => {
    try {
      await axiosClientSignIn.delete(`/domains/${domainId}`);
      return domainId;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const domainSlice = createSlice({
  name: "domains",
  initialState: {
    domains: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchDomains.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDomains.fulfilled, (state, action) => {
        state.loading = false;
        state.domains = action.payload;
      })
      .addCase(fetchDomains.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create
      .addCase(createDomain.fulfilled, (state, action) => {
        state.domains.push(action.payload);
      })

      // Update
      .addCase(updateDomain.fulfilled, (state, action) => {
        const idx = state.domains.findIndex(d => d._id === action.payload._id);
        if (idx !== -1) {
          state.domains[idx] = action.payload;
        }
      })

      // Delete
      .addCase(deleteDomain.fulfilled, (state, action) => {
        state.domains = state.domains.filter(d => d._id !== action.payload);
      });
  },
});

export default domainSlice.reducer;
